import { NgModule } from '@angular/core';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { GenericErrorModalComponent } from './generic-error-modal.component';
import { OpenModalDirective } from './open-modal.directive';

const directives = [OpenModalDirective];
@NgModule({
  imports: [
    AnalyticsDirectivesModule,
    ModalComponent,
    ModalBodyDirective,
    RichTextWrapperComponent,
    AutomationIdDirective,
    GenericErrorModalComponent,
    ...directives,
  ],
  exports: [...directives],
})
export class GenericErrorModalModule {}
